import React from "react";
import DashboardLayout from "../../layout/DashboardLayout.js";
// import ProfileDetails from "./ProfileDetails.js";
import UserListsDetails from "./UserListsDetails.js";
// import { Box } from "@mui/material";
// import { getUserById } from "../../services/userService";


function ListView() {
  // const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <DashboardLayout pageName="Profile">
      {/* <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' },  gap: 2}}> */}
        <UserListsDetails />
      {/* </Box> */}
    </DashboardLayout>
  );
}

export default ListView;